import styles from './index.module.css'

export default function Loader({ message, show }: IProps) {
  return <div className={`${styles.loader} ${show ? styles.show : null}`}>{message}</div>
}

interface IProps {
  message?: string
  show?: boolean
}
